import React, { useState } from "react";
import { useController, useWatch } from "react-hook-form";
import Editor from "../../SunEditor";
import FormJson from "../../../components/Forms/FormJson";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import FormFile from "../../../components/Forms/FormFile";
import FormColorTC from "../../../components/Forms/FormColorTC";
import { Card, GridLegacy } from "@mui/material";
import CardBody from "../../../components/Card/CardBody";
import { authenticationMode } from "../../../store/reducers/permissions";

const EditorAndMirror = ({ textareaName, initialValue, onChange, value }) => {
  const [editorInstance, setEditorInstance] = useState(null);

  const handleEditorInstance = (sunEditor) => {
    setEditorInstance(sunEditor);
  };

  const handleMirrorChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
    if (editorInstance) {
      editorInstance.setContents(newValue);
    }
  };

  return (
    <>
      <Editor
        defaultValue={value}
        getSunEditorInstance={handleEditorInstance}
        key={initialValue}
        onChange={onChange}
        textareaName={textareaName}
      />
      {authenticationMode ? (
        <textarea
          onChange={handleMirrorChange}
          style={{ width: "100%", height: "100px", marginTop: "8px", padding: "8px", border: "1px solid #ddd" }}
          value={value || ""}
        />
      ) : null}
    </>
  );
};

const Customize = () => {
  const [init1, setInit1] = useState(null);
  const [init2, setInit2] = useState(null);
  const [init3, setInit3] = useState(null);
  const [init4, setInit4] = useState(null);

  const {
    field: { value: htmlContent1Value, onChange: htmlContent1OnChange },
  } = useController({ name: "htmlContent1" });
  const {
    field: { value: htmlContent2Value, onChange: htmlContent2OnChange },
  } = useController({ name: "htmlContent2" });
  const {
    field: { value: htmlContent3Value, onChange: htmlContent3OnChange },
  } = useController({ name: "htmlContent3" });
  const {
    field: { value: htmlContent4Value, onChange: htmlContent4OnChange },
  } = useController({ name: "htmlContent4" });

  if (init1 == null && htmlContent1Value !== init1) setInit1(htmlContent1Value);
  if (init2 == null && htmlContent2Value !== init2) setInit2(htmlContent2Value);
  if (init3 == null && htmlContent3Value !== init3) setInit3(htmlContent3Value);
  if (init4 == null && htmlContent4Value !== init4) setInit4(htmlContent4Value);

  const masterCodeType = useWatch({ name: "masterCodeType" });

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <FormFieldTwoColumns tDefault={"Custom image"} tKey={"tafels.form.customize.label.afbeelding"}>
              <FormFile canCrop={true} name={"imgid"} nullable={true} type={"image"} />
            </FormFieldTwoColumns>
            <FormFieldTwoColumns tDefault={"Custom image 2"} tKey={"tafels.form.customize.label.afbeelding2"}>
              <FormFile canCrop={true} name={"imgid2"} nullable={true} type={"image"} />
            </FormFieldTwoColumns>
            <FormColorTC
              name={"buttoncolor"}
              tDefault={"Button color"}
              tKey={"tafels.form.customize.label.buttoncolor"}
            />
            <FormColorTC name={"bgcolor"} tDefault={"Background color"} tKey={"tafels.form.customize.label.bgcolor"} />
            <FormFieldTwoColumns
              tDefault={"Postalcheck page: header text"}
              tKey={"tafels.form.customize.label.htmlContent1"}
            >
              <EditorAndMirror
                initialValue={init1}
                onChange={htmlContent1OnChange}
                textareaName={"htmlContent1"}
                value={htmlContent1Value}
              />
            </FormFieldTwoColumns>
            <FormFieldTwoColumns
              tDefault={"Postalcheck page: not found text"}
              tKey={"tafels.form.customize.label.htmlContent2"}
            >
              <EditorAndMirror
                initialValue={init2}
                onChange={htmlContent2OnChange}
                textareaName={"htmlContent2"}
                value={htmlContent2Value}
              />
            </FormFieldTwoColumns>
            <FormFieldTwoColumns tDefault={"Custom button screen"} tKey={"tafels.form.customize.label.htmlContent3"}>
              <EditorAndMirror
                initialValue={init3}
                onChange={htmlContent3OnChange}
                textareaName={"htmlContent3"}
                value={htmlContent3Value}
              />
            </FormFieldTwoColumns>
            <FormFieldTwoColumns tDefault={"Edit content block 4"} tKey={"tafels.form.customize.label.htmlContent4"}>
              <EditorAndMirror
                initialValue={init4}
                onChange={htmlContent4OnChange}
                textareaName={"htmlContent4"}
                value={htmlContent4Value}
              />
            </FormFieldTwoColumns>

            {masterCodeType === 131 ? (
              <>
                <FormTextTC
                  name={"mastercodeJson.131.page_title"}
                  tDefault={"Page title"}
                  tKey={"masterCodeType.131.page_title"}
                />
                <FormTextTC
                  name={"mastercodeJson.131.page_subtitle"}
                  tDefault={"Page subtitle"}
                  tKey={"masterCodeType.131.page_subtitle"}
                />
              </>
            ) : null}

            <FormJson
              name={"mastercodeJson"}
              tDefault={"mastercode settings (JSON)"}
              tKey={"tafels.form.customize.label.mastercodeJson"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
};

export default Customize;
